<template>
  <div>
    <v-row>
      <v-col cols='12'>
        <wc-timepicker
          label='Default start time'
          :increment='$store.state.misc.settings.timesheet_increment'
          v-model='value.default_start'
        ></wc-timepicker>
      </v-col>
      <v-col cols='12'>
        <wc-timepicker
          label='Default end time'
          :increment='$store.state.misc.settings.timesheet_increment'
          v-model='value.default_end'
        ></wc-timepicker>
      </v-col>
      <v-col cols='12'>
        <v-checkbox
          hide-details
          label='Can be lead?'
          v-model='value.can_be_lead'
        ></v-checkbox>
      </v-col>
      <v-col cols='12'>
        <v-checkbox
          hide-details
          label='High season help?'
          v-model='value.high_season_help'
        ></v-checkbox>
      </v-col>
      <v-col cols='12'>
        <v-checkbox
          hide-details
          label='Is a subcontractor?'
          v-model='value.is_subcontractor'
        ></v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'profile-confidentials-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  }
}
</script>
